import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Shield, CreditCard, Flame } from 'lucide-react';
import { Button } from './ui/Button';
import { goToCheckout } from '../constants/checkout';
export function Hero() {
  return <section className="relative min-h-screen flex items-center pt-20 pb-16 overflow-hidden bg-dark-bg" data-id="element-41">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-hex-pattern opacity-50" data-id="element-42"></div>
      <div className="absolute inset-0 bg-hero-glow" data-id="element-43"></div>

      {/* Grid lines */}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#00aaff1a_1px,transparent_1px),linear-gradient(to_bottom,#00aaff1a_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)]" data-id="element-44"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-45">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-8" data-id="element-46">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 flex flex-col items-center lg:items-start text-center lg:text-left" data-id="element-47">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-electric-blue/10 border border-electric-blue/30 mb-6 backdrop-blur-sm" data-id="element-48">
              <Flame className="w-5 h-5 text-electric-blue" data-id="element-49" />
              <span className="text-electric-blue font-bold text-sm tracking-wider uppercase" data-id="element-50">
                Oferta especial de lanzamiento
              </span>
            </div>

            <h1 className="text-6xl md:text-7xl lg:text-8xl font-teko font-bold leading-[0.9] mb-6 text-white drop-shadow-2xl" data-id="element-51">
              RECUPERÁ EL{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-electric-blue to-blue-400 text-glow-blue" data-id="element-52">
                CONTROL
              </span>
              <br data-id="element-53" />
              DESDE EL PRIMER DÍA
            </h1>

            <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-2xl font-medium leading-relaxed" data-id="element-54">
              Sistema de entrenamiento de 21 días para controlar la eyaculación
              precoz + protocolo exclusivo para ayudarte a sentir más confianza
              y control desde tu próximo encuentro.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10 w-full max-w-2xl" data-id="element-55">
              {['Método paso a paso', 'Resultados progresivos', 'Acceso inmediato', '100% privado y confidencial', 'Incluye bonus exclusivos'].map((bullet, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.4 + idx * 0.1
            }} className="flex items-center gap-3 bg-panel-bg/50 border border-white/5 p-3 rounded-lg backdrop-blur-sm" data-id="element-56">
                  <CheckCircle2 className="w-5 h-5 text-electric-blue shrink-0" data-id="element-57" />
                  <span className="text-gray-200 text-sm font-semibold" data-id="element-58">
                    {bullet}
                  </span>
                </motion.div>)}
            </div>

            <div className="flex flex-col sm:flex-row gap-4 w-full max-w-2xl" data-id="element-59">
              <Button variant="primary" size="lg" className="w-full sm:w-auto" onClick={goToCheckout} data-id="element-60">
                COMENZAR AHORA
              </Button>
              <Button variant="outline" size="lg" className="w-full sm:w-auto" onClick={() => document.getElementById('que-incluye')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-61">
                VER TODO LO QUE INCLUYE
              </Button>
            </div>

            <div className="flex flex-wrap justify-center lg:justify-start gap-6 mt-8 text-sm text-gray-400 font-medium" data-id="element-62">
              <div className="flex items-center gap-2" data-id="element-63">
                <Shield className="w-4 h-4 text-gray-500" data-id="element-64" />
                <span data-id="element-65">Compra privada y segura</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-66">
                <CreditCard className="w-4 h-4 text-gray-500" data-id="element-67" />
                <span data-id="element-68">Cuotas disponibles</span>
              </div>
            </div>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9,
          filter: 'blur(10px)'
        }} animate={{
          opacity: 1,
          scale: 1,
          filter: 'blur(0px)'
        }} transition={{
          duration: 1,
          delay: 0.2
        }} className="w-full lg:w-1/2 relative" data-id="element-69">
            <div className="absolute inset-0 bg-electric-blue/20 blur-[100px] rounded-full" data-id="element-70"></div>
            <img src="https://cdn.magicpatterns.com/uploads/1CK3EqbmsoG6eRKEFipH2b/ChatGPT_Image_19_jun_2026,_00_12_30.png" alt="Control Total Hoy Pack" className="relative z-10 w-full max-w-2xl mx-auto drop-shadow-[0_0_30px_rgba(0,170,255,0.3)] hover:drop-shadow-[0_0_50px_rgba(0,170,255,0.5)] transition-all duration-500" data-id="element-71" />
          </motion.div>
        </div>
      </div>
    </section>;
}